import React from 'react'
import { IssuingModifyUsers } from './issuingModifyUsers'

export const IssuingModifyUser = () => {
  return (
    <IssuingModifyUsers />
  )
}
